import { hysteriFetch, wrappers } from 'hysterics';

const locationServiceFetcher = hysteriFetch('location-service.rest-v1');

export const API = {
	/**
	 * Fetches fresh account data including hours for a given accountId
	 * Used when client-side navigation occurs to refresh stale location data
	 */
	getAccountData: async (accountId) => {
		const fetchHeaders = new Headers();
		fetchHeaders.append('Accept', 'application/json');
		fetchHeaders.append('Content-Type', 'application/json');

		try {
			const response = await locationServiceFetcher(
				`/api/widget/ws-vehicle-location/accountData/${accountId}`,
				{
					method: 'GET',
					headers: fetchHeaders
				},
				{
					[wrappers.retry.contextKey]: {
						retries: 1
					}
				}
			);
			return response;
		} catch (err) {
			return { error: `Error retrieving account data: ${err.message}` };
		}
	},

	getDistanceFromLS: async (
		userPostalCode,
		vehicleLat,
		vehicleLong,
		locale
	) => {
		const fetchHeaders = new Headers();
		fetchHeaders.append('pragma', 'cache');
		fetchHeaders.append('cache-control', 'cache');
		fetchHeaders.append('Accept', 'application/json');
		fetchHeaders.append('Content-Type', 'application/json');

		try {
			const locationFetch = await locationServiceFetcher(
				`/api/widget/ws-vehicle-location/getDistance/${userPostalCode}/${vehicleLat}/${vehicleLong}/${locale}`,
				{
					method: 'POST',
					headers: fetchHeaders
				},
				{
					[wrappers.retry.contextKey]: {
						retries: 1
					}
				}
			);
			return locationFetch;
		} catch (err) {
			return `Error retrieving location: ${err.message}`;
		}
	}
};
